import { ReduxService } from 'dashboard-services/services';

import { dataVerificationModalPipelineCreatorActions } from 'actions/modules/datascience';

export const dataVerificationModalInitialState = {
  nodeId: undefined,
  open: false,
  outputKey: undefined,
  value: undefined, 
  valueType: undefined
}

export default (state = dataVerificationModalInitialState, action) => {
  switch(action.type) {
    case dataVerificationModalPipelineCreatorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case dataVerificationModalPipelineCreatorActions.CLEAN:
      return dataVerificationModalInitialState;
    default:
      return state
  }
}